<template>
  <v-app id="inspire">
    <v-snackbar v-model="globalAlert.show" :top="true" :color="globalAlert.color">
      <span>{{ globalAlert.message }}</span>
    </v-snackbar>
    <TopNavigation />
    <LeftNavigation />

    <v-content dark>
      <router-view></router-view>
    </v-content>

    <v-dialog v-model="globalLoader.show" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ globalLoader.message }}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <BottomNavigation />

    <CookiesSnackBar />
  </v-app>
</template>

<script>
import Controller from "@/mixins/controlsMixins";
import * as types from "@/store/types";
import LeftNavigation from "@/components/navigations/LeftNavigation.vue";
import TopNavigation from "@/components/navigations/TopNavigation.vue";
import BottomNavigation from "@/components/navigations/BottomNavigation.vue";
import CookiesSnackBar from "@/components/widgets/CookiesSnackBar";

export default {
  name: "App",
  components: {
    LeftNavigation,
    TopNavigation,
    BottomNavigation,
    CookiesSnackBar
  },
  mixins: [Controller],
  mounted() {
    this.openGlobalLoader("Načítavam ...");
    this.$store
      .dispatch("checkAuthentification")
      .then(() => {
        console.log("Logged");
      })
      .finally(() => {
        this.closeGlobalLoader();
      }); // tu by sa malo pockat na promise
  },
  created() {
    let test = false;
    if (test) {
      // console.log('%c ', 'background: url(' + this.img + ');background-repeat: no-repeat; background-size: 300px 42px; font-size: 42px; margin: 10px;  padding-right: 300px')
      // console.log('%c ', 'background: url(' + this.img2 + ');background-repeat: no-repeat; background-size: 220px 44px; font-size: 44px; margin-left: 30px; padding-right: 220px')
      if (!window.console) window.console = {};
      var methods = ["log", "debug", "warn", "info", "error"];
      for (var i = 0; i < methods.length; i++) {
        console[methods[i]] = function() {};
      }
    }
  },
  computed: {
    globalAlert: {
      get() {
        return this.$store.getters.globalAlert;
      },
      set(value) {
        this.$store.commit(types.SHOW_GLOBAL_ALERT, {
          value: value,
          message: ""
        });
      }
    },
    globalLoader: {
      get() {
        return this.$store.getters.globalLoader;
      },
      set(value) {
        this.$store.commit(types.SHOW_GLOBAL_LOADER, {
          value: value,
          message: ""
        });
      }
    }
  }
};
</script>

<style>
.v-navigation-drawer__border {
  display: none;
}

* {
  /* font-family: "Raleway", sans-serif; */
  font-family: "Montserrat", sans-serif;
}

* {
  text-transform: none !important;
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
</style>